"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareKey = void 0;
function prepareKey(val) {
    return String(val)
        .toLowerCase()
        .trim()
        .replace(/\r?\n|\r/, '');
}
exports.prepareKey = prepareKey;
